export * from './lib/pages/registration-confirmation/registration-confirmation.component';
export * from './lib/registration-feature-registration-confirmation.routes';
